import axios from '../../axios'

// 新增招录院校统考类型
export const addSchoolType = (data) => {
    return axios({
        url: '/api/data/wish/admission/school/type',
        method: 'POST',
        data
    })
}

// 修改招录院校统考类型
export const editSchoolType = (data) => {
    return axios({
        url: '/api/data/wish/admission/school/type',
        method: 'PUT',
        data
    })
}

// 获取招录院校统考类型详情
export const getSchoolType = (data) => {
    return axios({
        url: '/api/data/wish/admission/school/type/info',
        method: 'GET',
        data
    })
}

// 删除招录院校统考类型
export const deleteSchoolType = (data) => {
    return axios({
        url: '/api/data/wish/admission/school/type',
        method: 'DELETE',
        data
    })
}

// 获取招录院校统考类型列表
export const getSchoolTypeList = (data) => {
    return axios({
        url: '/api/data/wish/admission/school/type',
        method: 'GET',
        data
    })
}

// 导入招录院校统考类型
export const importSchoolType = (data) => {
    return axios({
        url: '/api/data/wish/admission/school/type/import',
        method: 'POST',
        data
    })
}

// 导出招录院校统考类型
export const exportSchoolType = (data) => {
    return axios({
        url: '/api/data/wish/admission/school/type/export',
        method: 'POST',
        data
    })
}

// 批量更新招录院校统考类型
export const updateSchoolType = (data) => {
    return axios({
        url: '/api/data/wish/admission/school/type/batch/update',
        method: 'POST',
        data
    })
}

// 批量删除招录院校统考类型
export const allDeleteSchoolType = (data) => {
    return axios({
        url: '/api/data/wish/admission/school/type/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/schooltype.js